import SimpleHeader from '../../../../components/Headers/SimpleHeader';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import ReactLoader from '../../../../components/Loader';
import BootstrapTable from 'react-bootstrap-table-next';
import { formatter } from '../../GasOrder/list/utils';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import Pagination from 'components/Pagination';
import { useGetFamily } from '../hooks/useGetFamily';
import { useGetUnity } from '../hooks/useGetUnity';
import ProductService from '../service';
import {
  Container,
  Row,
  Card,
  CardHeader,
  Button,
  Input,
  Col,
  FormGroup,
  Label,
  InputGroup,
  InputGroupAddon,
  InputGroupText
} from 'reactstrap';

import {
  icon_column_style,
  individual_column_style,
  individual_header_style
} from '../../../../assets/styles/table_custom_style';

const Product = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [productData, setProductdata] = useState([]);
  const [quantity, setQuantity] = useState(0);
  const [activePage, setActivePage] = useState(1);
  const [timeoutID, setTimeoutID] = useState(null);

  const history = useHistory();

  const { families } = useGetFamily();
  const { unities } = useGetUnity();

  const handlePageChange = (activePage) => {
    setActivePage(activePage);
    getProducts(activePage);
  };

  useEffect(() => {
    getProducts();
  }, [families, unities]);

  function handleUpdate(id) {
    history.push(`gasOrderProducts/form/${id}`);
  }

  async function getProducts(page, querySearch) {
    const size = 10;

    setIsLoading(true);

    await ProductService.getAllSearch(false, size, page, querySearch)
      .then((res) => {
        setQuantity(res.data.totalRegisters);
        let formatedResponseData = res.data.data.map((product) => {
          let familia;

          let medida;

          let newObject = {
            ativo: product.ativo,
            code: product.codigo,
            criadoPor: product.criadoPor,
            descricao: product.descricao,
            family: familia,
            id: product.id,
            name: product.nome,
            value: `${
              product.preco == null ? formatter(0) : formatter(product.preco)
            }`,
            measure: medida,
            discount: 0,
            amount: 1,
            editable: false,
            disabled: false
          };

          return newObject;
        });

        setProductdata(formatedResponseData);
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  const handleOnSearch = (event) => {
    if (typeof timeoutID === 'number') {
      clearTimeout(timeoutID);
    }
    const q = event.target.value;
    setTimeoutID(
      setTimeout(() => {
        getProducts(1, q);
      }, 1000)
    );
  };

  return (
    <>
      <SimpleHeader
        setCreate="/admin/gasOrderProducts/form/"
        name="Form validation"
        parentName="Forms"
        returnPath="/admin/dashboard"
      />
      <Container className="mt--6" fluid>
        <Row>
          <div className="col">
            <div className="card-wrapper">
              <Card>
                <CardHeader>
                  <h3 className="mb-0">Produtos</h3>
                </CardHeader>

                <Row className="mt-3 mx-2">
                  <Col md="8">
                    <InputGroup>
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          <i className="fas fa-search" />
                        </InputGroupText>
                      </InputGroupAddon>
                      <Input
                        placeholder="Busca por nome do produto"
                        type="text"
                        defaultValue=""
                        onChange={handleOnSearch}
                      />
                    </InputGroup>
                  </Col>
                  <Col md="4" className="text-right mt-2 mt-md-1">
                    <FormGroup check>
                      <Label check>
                        <Input
                          type="checkbox"
                          // checked={showDisabled}
                          // onChange={() => setShowDisable(!showDisabled)}
                        />
                        <span>Mostar desabilitados</span>
                      </Label>
                    </FormGroup>
                  </Col>
                </Row>

                <ToolkitProvider
                  data={productData}
                  keyField="uuid"
                  columns={[
                    {
                      dataField: 'code',
                      text: 'CODE',
                      editable: false,
                      sort: true,
                      style: individual_column_style,
                      headerStyle: individual_header_style
                    },
                    {
                      dataField: 'name',
                      text: 'NAME',
                      editable: false,
                      sort: true,
                      style: individual_column_style,
                      headerStyle: individual_header_style
                    },
                    {
                      dataField: 'family',
                      text: 'FAMÍLIA',
                      editable: false,
                      sort: true,
                      style: individual_column_style,
                      headerStyle: individual_header_style
                    },
                    {
                      dataField: 'measure',
                      text: 'MEDIDA',
                      editable: false,
                      sort: true,
                      style: individual_column_style,
                      headerStyle: individual_header_style
                    },
                    {
                      dataField: 'value',
                      text: 'VALOR',
                      sort: true,
                      style: individual_column_style,
                      headerStyle: individual_header_style
                    },
                    // {
                    //   dataField: 'discount',
                    //   text: 'DESCONTO',
                    //   sort: true,
                    //   style: individual_column_style,
                    //   headerStyle: individual_header_style
                    // },
                    // {
                    //   dataField: 'amount',
                    //   text: 'QUANTIDADE',
                    //   sort: true,
                    //   style: individual_column_style,
                    //   headerStyle: individual_header_style
                    // },
                    {
                      dataField: 'edit',
                      style: icon_column_style,
                      headerStyle: {
                        ...individual_header_style,
                        textAlign: 'center'
                      },
                      text: 'Editar',
                      // eslint-disable-next-line react/display-name
                      formatter: (_, row) => {
                        return (
                          <Button
                            size="sm"
                            disabled={row.disable}
                            color="info"
                            onClick={() => handleUpdate(row.id)}
                          >
                            <li className="fas fa-user-edit"></li>
                          </Button>
                        );
                      }
                    }
                  ]}
                >
                  {(props) => (
                    <div className="py-4 table-responsive">
                      {/* <SearchTable handleOnSearch={handleOnSearch} /> */}

                      <Row
                        style={{
                          display: `${isLoading ? 'flex' : 'none'}`,
                          justifyContent: 'center'
                        }}
                        className="justify-content-md-center"
                      >
                        <ReactLoader />
                      </Row>

                      <div
                        style={{ display: `${isLoading ? 'none' : 'initial'}` }}
                        className="py-4 table-responsive"
                      >
                        <BootstrapTable
                          {...props.baseProps}
                          bootstrap4={true}
                          keyField="id"
                          bordered={false}
                          classes="align-items-center"
                          noDataIndication="Nenhum produto encontrado"
                          // selectRow={selectRow}
                        />
                      </div>
                    </div>
                  )}
                </ToolkitProvider>
                <Pagination
                  activePage={activePage}
                  totalItemsCount={quantity}
                  onChange={handlePageChange.bind(this)}
                />
              </Card>
            </div>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default Product;
